'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { MoreVerticalIcon } from '@terra/ui-icons';
import { IconButton } from '../../components/icon-button';
import { Popover } from '../../components/popover';

export type ListPageOptionsMenuProps = {
  children: ReactNode;
};

export function ListPageOptionsMenu({ children }: ListPageOptionsMenuProps) {
  const t = useTranslations('designSystem.listPage');

  return (
    <Popover.Root positioning={{ strategy: 'fixed', placement: 'bottom-end' }}>
      <Popover.Trigger asChild>
        <IconButton size="2xs" variant="outline" aria-label={t('moreOptions')}>
          <MoreVerticalIcon size={14} />
        </IconButton>
      </Popover.Trigger>
      <Popover.Positioner>
        <Popover.Content
          p="2"
          w="320px"
          borderColor="border.neutral.subtle"
          borderWidth="1px"
          borderRadius="l3"
          boxShadow="md"
        >
          <VStack gap="1" alignItems="stretch">
            {children}
          </VStack>
        </Popover.Content>
      </Popover.Positioner>
    </Popover.Root>
  );
}
